import React from "react"
export default function Alert({ message }) {
    return (
        <div className='alert alert-info my-2 text-center'>
            {message}
        </div>
    )
}